<template>
  <div>
    <v-btn icon @click="abrirDialog">
      <v-icon>mdi-pencil</v-icon>
    </v-btn>

    <SysDialog v-model="dialog_ativo" titulo="Edição" ocultar-acoes :largura="500">
      <p class="font-14 text-gray-1100">
        Existem diferentes escopos de cobertura cadastrados. Qual deseja editar?
      </p>

      <div class="d-flex w-full">
        <v-card
          class="w-50-porcento mr-2 py-5 text-center text-gray-1000 font-14"
          @click="edicaoGeral"
        >
          <v-icon :size="30">mdi-home-group</v-icon>
          <p class="ma-0">Cobertura Geral</p>
        </v-card>

        <v-card
          class="w-50-porcento ml-2 py-5 text-center text-gray-1000 font-14"
          @click="edicaoPorFilial"
        >
          <v-icon :size="30">mdi-home-edit</v-icon>
          <p class="ma-0">Cobertura por Filial</p>
        </v-card>
      </div>
    </SysDialog>
  </div>
</template>

<script setup>
import {ref} from "vue";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";

const props = defineProps({
  item: Object,
});

const emit = defineEmits(['edicao:geral', 'edicao:por-filial']);

const dialog_ativo = ref(false);

function abrirDialog() {
  if (!props.item.tempo_cobertura_por_filial) {
    edicaoGeral();
    return;
  }

  if (!props.item.tempo_cobertura) {
    edicaoPorFilial();
    return;
  }

  dialog_ativo.value = true;
}

function edicaoGeral() {
  emit('edicao:geral', props.item);
  dialog_ativo.value = false;
}

function edicaoPorFilial() {
  emit('edicao:por-filial', props.item);
  dialog_ativo.value = false;
}
</script>
